<template>
  <div class="pd-page">
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>datamap中存在scene列,请选择是否删除?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tagToSceneOn(2)">不删除</el-button>
        <el-button type="danger" @click="tagToSceneOn(1)">删除</el-button>
      </span>
    </el-dialog>

    <!-- 页头 -->
    <header class="pd-header">
      <div class="pd-shell pd-header-inner">
        <button class="pd-back" type="button" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </button>
        <div class="pd-heading">
          <h1>项目数据</h1>
        </div>
        <span class="pd-meta">{{ ppcode }} · {{ ppname }}</span>
      </div>
    </header>

    <!-- 主体 -->
    <main class="pd-shell pd-main">
      <el-row :gutter="20" class="pd-grid">
        <!-- 左：项目数据 -->
        <el-col :xs="24" :sm="24" :md="12">
          <section class="pd-card">
            <div class="pd-card-head">
              <div class="pd-card-title">
                <h2>项目数据表</h2>
                <p>datamap + rawdata 双表结构</p>
              </div>
            </div>

            <el-upload
              v-loading="loading"
              :show-file-list="false"
              class="pd-upload"
              drag
              :action="pdata.upUrl"
              :headers="{ Authorization: token}"
              name="basedata"
              accept=".xls,.xlsx"
              :limit="20"
              :before-upload="beforeAvatarUpload"
              :on-success="onSuccess"
              :data="{pid: pid }"
            >
              <div class="pd-drop">
                <p class="pd-drop-title">将<em>项目数据</em>表格拖到此处，或<em>点击上传</em></p>
                <p class="pd-drop-sub">支持 .xls / .xlsx 格式</p>
              </div>
            </el-upload>

            <!-- 已上传文件 + 操作 -->
            <div v-if="pdata.fileName.length" class="pd-filepanel">
              <div class="pd-file">
                <img src="@/assets/excel.jpg" class="pd-file-icon" />
                <div class="pd-file-info">
                  <p class="pd-file-name">{{ pdata.fileName }}</p>
                  <p class="pd-file-meta" v-if="pdata.upuser != null && pdata.upuser != ''">
                    <span><i class="el-icon-user"></i>{{ pdata.upuser }}</span>
                    <span><i class="el-icon-time"></i>{{ pdata.uptime }}</span>
                  </p>
                </div>
              </div>
              <div class="pd-actions">
                <el-button
                  class="pd-btn-main"
                  size="small"
                  icon="el-icon-magic-stick"
                  @click="tagToScene"
                  :loading="loading"
                >数据处理</el-button>
                <el-button
                  class="pd-btn-plain"
                  size="small"
                  icon="el-icon-search"
                  @click="checkVar"
                  :loading="loading"
                >变量检查</el-button>
                <el-button
                  class="pd-btn-plain"
                  size="small"
                  icon="el-icon-download"
                  @click="pdowndata(pdata.fileName,'projectDataDown')"
                  :loading="loading"
                >数据下载</el-button>
                <el-button
                  class="pd-btn-danger"
                  size="small"
                  icon="el-icon-delete"
                  @click="del(pdata.fileName)"
                  :loading="loading"
                >数据删除</el-button>
              </div>
            </div>

            <!-- 样本下载：按状态筛选rawdata生成新数据表 -->
            <div v-if="pdata.fileName.length" class="pd-sample">
              <div class="pd-sample-row">
                <span class="pd-sample-label">样本下载</span>
                <div class="pd-sample-ops">
                  <el-select v-model="sampleStatus" size="small" class="pd-sample-select">
                    <el-option v-for="item in sampleStatusOptions" :key="item.v" :label="item.k" :value="item.v">
                    </el-option>
                  </el-select>
                  <el-button class="pd-btn-main" size="small" icon="el-icon-download"
                    :loading="sampling" @click="sampleDown">下载样本</el-button>
                </div>
              </div>
              <p class="pd-sample-note">
                <i class="el-icon-info"></i>仅导出筛选后的 rawdata（不含 datamap）；若 rawdata 中无 Status 列将提示并终止下载
              </p>
            </div>

            <!-- 数据检验 -->
            <div v-if="check.ischeck" class="pd-checkbar">
              <span class="pd-checkbar-label">数据检验</span>
              <div class="pd-checkbar-ops">
                <el-button
                  class="pd-btn-plain"
                  size="small"
                  @click="checkoutRun"
                  :loading="loading"
                >{{ check.text }}</el-button>
                <el-button
                  class="pd-btn-plain"
                  size="small"
                  icon="el-icon-download"
                  @click="pdowndata(check.result,'projectCheckoutDown')"
                  :loading="loading"
                >检测结果下载</el-button>
              </div>
            </div>
          </section>
        </el-col>

        <!-- 右：备份数据 -->
        <el-col :xs="24" :sm="24" :md="12">
          <section class="pd-card">
            <div class="pd-card-head">
              <div class="pd-card-title">
                <h2>备份数据</h2>
                <p>可同时上传多个数据表备份</p>
              </div>
              <span v-if="otherData.length" class="pd-count">{{ otherData.length }}</span>
            </div>

            <el-upload
              v-loading="loading2"
              :show-file-list="false"
              class="pd-upload"
              drag
              :action="upUrl2"
              :headers="{ Authorization: token}"
              name="otherdata"
              :limit="20"
              :before-upload="beforeAvatarUpload2"
              multiple
              :on-success="onSuccess2"
              :data="{pid: pid }"
            >
              <div class="pd-drop">
                <p class="pd-drop-title">将<em>备份数据</em>表格拖到此处，或<em>点击上传</em></p>
                <p class="pd-drop-sub">支持多个文件同时上传</p>
              </div>
            </el-upload>

            <ul v-if="otherData.length" class="pd-backup-list">
              <li v-for="(item,index) in otherData" :key="index" class="pd-backup-item">
                <span class="pd-backup-name">{{ item }}</span>
                <span class="pd-backup-ops">
                  <el-button type="text" @click="pdowndata(item,'projectDataOhterDown')">下载</el-button>
                  <el-button type="text" class="pd-danger-text" @click="del2(item)">删除</el-button>
                </span>
              </li>
            </ul>
            <div v-else class="pd-backup-empty">
              <i class="el-icon-folder-opened"></i>
              <p>暂无备份文件，上传后将显示在此处</p>
            </div>
          </section>
        </el-col>
      </el-row>
    </main>
  </div>
</template>
<script>
export default {
  name: "ProjectData",
  props: ["pid", "ppname", "ppcode"],
  data() {
    return {
      loading: false,
      loading2: false,
      token:"Bearer " + localStorage.getItem("token"),
      pdata: {
        fileName: "",
        upuser:"",
        uptime:"",      
        upUrl: this.COMMON.httpUrl +"projectDataUpload",
      },
      check:{
        result:"",
        ischeck:"",
        text:""
      },
      con:"0",
      dialogVisible:false,
      upUrl2: this.COMMON.httpUrl +"projectOtherUpload",
      otherData:[],
      // 样本下载
      sampling: false,
      sampleStatus: 5,
      sampleStatusOptions: [
        { k: "All", v: 5 },
        { k: "Complete", v: 1 },
        { k: "Incomplete", v: 2 },
        { k: "Screened", v: 3 },
        { k: "QuotaFull", v: 4 },
      ],
    };
  },
  created() {
    this.getData();
    // this.pdata.upurl =
    //   this.COMMON.httpUrl +"projectDataUpload";
    //   this.upUrl2 =
    //   this.COMMON.httpUrl +"projectOtherUpload";
  },
  methods: {
    getData() {
      var api = this.COMMON.httpUrl + "projectData";
      var data = { pid: this.pid };
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code == 0) {
          this.pdata.fileName = rs.data.fileName;
          this.pdata.upuser = rs.data.upuser;
          this.pdata.uptime = rs.data.uptime;
          this.otherData = rs.data.others;         
          this.check = rs.data.check;
          
        }
      });
    },
    beforeAvatarUpload(file) {
      if (this.pdata.fileName !== "") {
        this.$message({
          message: "请先删除原数据后再上传",
          type: "warning",
        });
        return false;
      }
      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = fileName === "xls";
      const extension2 = fileName === "xlsx";
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是 xls、xlsx格式!",
          type: "warning",
        });
        return false;
      }
      this.loading=true
    },
    beforeAvatarUpload2() {

      // let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      // const extension = fileName === "xls";
      // const extension2 = fileName === "xlsx";
      // if (!extension && !extension2) {
      //   this.$message({
      //     message: "上传文件只能是 xls、xlsx格式!",
      //     type: "warning",
      //   });
      //   return false;
      // }
      this.loading2=true
    },
    projectDataDel(name) {
      var api = this.COMMON.httpUrl + "projectDataDel";
      var data = { pid: this.pid, fileName: name};
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success(rs.message);
          this.pdata.fileName = "";
        }
      });
    },
    projectDataOtherDel(name) {
      var api = this.COMMON.httpUrl + "projectDataOtherDel";
      var data = { pid: this.pid, fileName: name};
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success(rs.message);
          this.otherData=rs.data      
        }
      });
    },
    del(name) {
      this.$confirm("项目数据删除后不可恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.projectDataDel(name);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    del2(name) {
      this.$confirm("项目数据删除后不可恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.projectDataOtherDel(name);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onSuccess(rs) {
      this.loading=false
      if (rs.code) {
        this.$message.error(rs.message);
      } else {
        // this.$message.success(rs.message);
        this.pdata.fileName = rs.data.filename;
        this.pdata.uptime=rs.data.uptime;
        this.pdata.upuser=rs.data.upuser;
        
      }
    },
    onSuccess2(rs) {
      if (rs.code) {
        this.$message.error(rs.message);
      } else {
        // this.$message.success(rs.message);
        this.otherData.push(rs.data)
      }
      this.loading2=false
    },
    tagToSceneOn(a) {   
      this.con=a
      this.tagToScene()
      this.dialogVisible=false
      this.con="0"
    },
    tagToScene() {      
      this.loading = true;
      var api = this.COMMON.httpUrl + "tagToScene";
      var data = { pid: this.pid ,con:this.con};
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        this.loading = false;
        if (rs.code) {
          if(rs.code==10){
           this.dialogVisible=true
          }else{
            this.$message.error(rs.message);
          }
          
        } else {
          this.$message.success(rs.message);
        }
      });
    },
    checkoutRun() {      
      this.loading = true;
      var api = this.COMMON.httpUrl + "projectCheckoutRun";
      var data = { pid: this.pid};
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        this.loading = false;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.check.text=rs.data;
          this.$message.success(rs.message);
        }
      });
    },
    checkVar() {      
      this.loading = true;
      var api = this.COMMON.httpUrl + "projectCheckVar";
      var data = { pid: this.pid};
      this.axios.post(api, data).then((response) => {
        var rs = response.data;
        this.loading = false;
        if (rs.code) {
          // this.$message.error(rs.message);
          this.$message.error({
          message: '<div style="white-space: pre-line;">'+rs.message+ '</div>',
          dangerouslyUseHTMLString: true,
      });
        } else {
          this.$message.success(rs.message);          
        }
      });
    },
    // 样本下载：按所选状态筛选rawdata生成新数据表
    sampleDown() {
      if (!this.pdata.fileName) {
        this.$message.warning("请先上传项目数据");
        return;
      }
      this.sampling = true;
      var api = this.COMMON.httpUrl + "projectSampleDown";
      var data = {
        pid: this.pid,
        fileName: this.pdata.fileName,
        status: this.sampleStatus,
        pname: this.ppname,
      };
      this.axios.post(api, data).then((response) => {
        this.sampling = false;
        var rs = response.data;
        if (rs.code) {
          this.$message.error(rs.message);
        } else {
          this.$message.success("样本数据下载中");
          window.location.href = rs.data;
        }
      }).catch(() => {
        this.sampling = false;
        this.$message.error("样本下载请求失败");
      });
    },
    // 文件下载
    pdowndata(fname,url) {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        body: JSON.stringify({ pid: this.pid,fileName:fname }),
      };

      let src = this.COMMON.httpUrl + url;
      fetch(src, requestOptions)
        .then((response) => {
          if (!response.ok) {
            // 如果响应不是成功的，尝试读取JSON格式的错误信息
            return response.json().then((errorData) => {
              // 假设错误数据是一个包含code和message的对象
              if (errorData.code && errorData.message) {
                // 抛出错误以便后续的.catch可以捕获
                throw new Error(errorData.message);
              } else {
                // 如果格式不符合预期，可以抛出一个通用的错误
                throw new Error("下载异常");
              }
            });
          }
          // console.log("response.ok:",response)
          
          return  response.blob()
        })
        // .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          // 文件名称可以在这里更改
          a.download = fname;
          a.href = url;
          a.click();
        })
        .catch(error => {
            // alert(error)      
            this.$message.error(error);  
        });
    },
  },
};
</script>

<style scoped>
/* ===== 页面框架（简洁版，与平台整体风格一致） ===== */
.pd-page {
  min-height: 100vh;
  background: #f5f7fa;
  color: #303133;
}
.pd-shell {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* ===== 页头 ===== */
.pd-header { border-bottom: 1px solid #ebeef5; }
.pd-header-inner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 10px;
}
.pd-back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  background: #fff;
  color: #606266;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}
.pd-back:hover {
  color: #409eff;
  border-color: #c6e2ff;
}
.pd-back i { font-size: 13px; }
.pd-heading h1 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #303133;
}
.pd-meta {
  margin-left: auto;
  font-size: 13px;
  color: #909399;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ===== 主体与卡片 ===== */
.pd-main { padding: 20px 10px 48px; }
.pd-main .pd-grid { display: flex; flex-wrap: wrap; }
.pd-card {
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;
}
.pd-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.pd-card-title h2 { margin: 0; font-size: 15px; font-weight: 600; color: #303133; }
.pd-card-title p { margin: 2px 0 0; font-size: 12px; color: #909399; }
.pd-count {
  margin-left: auto;
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  border-radius: 10px;
  background: #f0f2f5;
  color: #606266;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ===== 上传区 ===== */
.pd-drop { padding: 22px 16px; text-align: center; }
.pd-drop-title { margin: 0; font-size: 14px; color: #606266; }
.pd-drop-title em { font-style: normal; font-weight: 600; color: #409eff; }
.pd-drop-sub { margin: 4px 0 0; font-size: 12px; color: #909399; }

/* ===== 文件面板与操作 ===== */
.pd-filepanel {
  margin-top: 12px;
  padding: 12px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}
.pd-file { display: flex; align-items: center; gap: 10px; }
.pd-file-icon {
  width: 28px;
  height: 28px;
  flex: none;
  object-fit: contain;
}
.pd-file-info { min-width: 0; }
.pd-file-name {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
  word-break: break-all;
}
.pd-file-meta {
  margin: 2px 0 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px 10px;
  font-size: 12px;
  color: #909399;
}
.pd-file-meta span { display: inline-flex; align-items: center; }
.pd-file-meta i { margin-right: 3px; font-size: 12px; }
.pd-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

/* ===== 样本下载卡片 ===== */
.pd-sample {
  margin-top: 12px;
  padding: 12px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}
.pd-sample-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.pd-sample-label { font-size: 13px; font-weight: 600; color: #303133; }
.pd-sample-ops {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.pd-sample-select { width: 160px; }
.pd-sample-note {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}
.pd-sample-note i { margin-right: 3px; }

/* ===== 数据检验条 ===== */
.pd-checkbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}
.pd-checkbar .pd-checkbar-label { font-size: 13px; font-weight: 600; color: #303133; }
.pd-checkbar-ops { margin-left: auto; display: flex; gap: 8px; }

/* ===== 备份数据列表 ===== */
.pd-backup-list {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  max-height: 260px;
  overflow-y: auto;
}
.pd-backup-list::-webkit-scrollbar { width: 6px; }
.pd-backup-list::-webkit-scrollbar-thumb { background: #e4e7ed; border-radius: 3px; }
.pd-backup-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  transition: background 0.15s;
}
.pd-backup-item + .pd-backup-item { margin-top: 2px; }
.pd-backup-item:hover { background: #f5f7fa; }
.pd-backup-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #606266;
  word-break: break-all;
}
.pd-backup-ops {
  flex: none;
  display: inline-flex;
  align-items: center;
}
.pd-backup-ops .el-button { padding: 0; }
.pd-backup-ops .el-button + .el-button { margin-left: 10px; }

/* ===== 备份空状态 ===== */
.pd-backup-empty {
  margin-top: 12px;
  padding: 28px 0;
  border: 1px dashed #e4e7ed;
  border-radius: 8px;
  text-align: center;
  color: #c0c4cc;
}
.pd-backup-empty i { font-size: 24px; }
.pd-backup-empty p { margin: 6px 0 0; font-size: 12px; }

/* ===== 响应式 ===== */
@media (max-width: 992px) {
  .pd-meta { display: none; }
}
</style>

<style>
/* Element UI 控件覆写（以 .pd-page 命名空间限定，不影响其他页面） */
.pd-page .pd-upload .el-upload { width: 100%; }
.pd-page .pd-upload .el-upload-dragger {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  background: #fafafa;
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  transition: border-color 0.2s;
}
.pd-page .pd-upload .el-upload-dragger:hover {
  border-color: #409eff;
}

/* 按钮 */
.pd-page .pd-btn-main.el-button {
  background: #409eff;
  border: none;
  color: #fff;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  transition: all 0.2s;
}
.pd-page .pd-btn-main.el-button:hover,
.pd-page .pd-btn-main.el-button:focus {
  background: #66b1ff;
  color: #fff;
}
.pd-page .pd-btn-plain.el-button {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  border-radius: 6px;
  font-weight: 400;
  font-size: 13px;
  transition: all 0.2s;
}
.pd-page .pd-btn-plain.el-button:hover,
.pd-page .pd-btn-plain.el-button:focus {
  border-color: #409eff;
  color: #409eff;
}
.pd-page .pd-btn-danger.el-button {
  background: #fff;
  border: 1px solid #fbc4c4;
  color: #f56c6c;
  border-radius: 6px;
  font-weight: 400;
  font-size: 13px;
  transition: all 0.2s;
}
.pd-page .pd-btn-danger.el-button:hover,
.pd-page .pd-btn-danger.el-button:focus {
  background: #fef0f0;
  border-color: #f56c6c;
  color: #f56c6c;
}
.pd-page .pd-actions .el-button + .el-button,
.pd-page .pd-sample-ops .el-button + .el-button,
.pd-page .pd-checkbar-ops .el-button + .el-button {
  margin-left: 0;
}

/* 样本状态下拉 */
.pd-page .pd-sample-select .el-input__inner {
  border-radius: 6px;
  border-color: #dcdfe6;
  color: #606266;
  font-size: 13px;
}
.pd-page .pd-sample-select .el-input__inner:hover { border-color: #c0c4cc; }
.pd-page .pd-sample-select .el-input__inner:focus { border-color: #409eff; }

/* 备份列表文字按钮 */
.pd-page .pd-backup-ops .el-button {
  padding: 0;
  font-size: 12px;
}
.pd-page .pd-backup-ops .el-button + .el-button { margin-left: 10px; }
.pd-page .pd-backup-ops .el-button:first-child { color: #409eff; }
.pd-page .pd-backup-ops .el-button:first-child:hover { color: #66b1ff; }
.pd-page .pd-backup-ops .pd-danger-text { color: #f56c6c; }
.pd-page .pd-backup-ops .pd-danger-text:hover { color: #f78989; }
</style>
